import { flattenEntry, getEntries } from '@/lib/cms';

import { EntryWithID, LimitPagination } from '@/cms/types/entry';
import { SearchResultProps } from '@/decodo/blocks/HeroWithSearch/SearchResultsList';

export type FaqItem = SearchResultProps[][number];

export function transformPagesIntoSearchProps(results: EntryWithID[]) {
  return results.map(
    (result) =>
      ({
        slug: result.slug,
        title: result.seo?.metaTitle,
      } satisfies FaqItem)
  );
}

export async function searchPages(filters?: {
  searchWithin: 'faq';
  slug?: string;
  query?: string;
  pagination?: { start: number; limit?: number };
  signal?: AbortSignal | null;
}) {
  const slugFilter =
    filters?.searchWithin === 'faq'
      ? { $containsi: 'faq' }
      : { $containsi: '' };

  const filterParams = !!filters
    ? {
        slug: slugFilter,
        seo: {
          ...(!!filters?.query && {
            metaTitle: {
              $containsi: filters.query,
            },
          }),
        },
      }
    : undefined;

  const entries = await getEntries({
    contentType: '/pages',
    query: {
      pLevel: 'deep,2',
      sort: 'createdAt',
      filters: filterParams,
    },
    signal: filters?.signal,
  });

  if (!entries) return null;
  if (!entries.data.length) return null;

  const pagination = entries.meta?.pagination;

  return {
    data: entries.data.map(flattenEntry),
    pagination: (pagination || {}) as LimitPagination,
  };
}
